function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const ROTATION_ANGLE = -90;
const IMAGE_QUALITY = 1;
class ImageRotator {
    rotate(blob) {
        return _async_to_generator(function*() {
            return new Promise((resolve)=>{
                const img = new Image();
                img.setAttribute('crossorigin', 'anonymous');
                img.src = URL.createObjectURL(blob);
                img.onload = function() {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    if (!ctx) return;
                    ctx.canvas.width = img.height;
                    ctx.canvas.height = img.width;
                    ctx.translate(canvas.width / 2, canvas.height / 2);
                    ctx.rotate(ROTATION_ANGLE * Math.PI / 180);
                    ctx.translate(-canvas.height / 2, -canvas.width / 2);
                    ctx.drawImage(img, 0, 0, img.width, img.height);
                    canvas.toBlob((updatedBlob)=>{
                        resolve(updatedBlob);
                    }, blob.type, IMAGE_QUALITY);
                };
            });
        })();
    }
}
export { ImageRotator };
